function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { connect } from "react-redux";
import Component from "../components/ChartRenderer";
import { fetchContent, fetchClaims, completeSlide, setCbookProgress, evaluateInteraction, startExam, initExam, fetchExamInteractions, sendNotification, nextSlide, login, fetchSocialChartData, updateSocialChartData, fetchCommunityChartData, endorseDisclaimer, fetchGroups, fetchUsers } from "../actions";
import ChartTypes from "../utils/ChartTypes";
import findKey from "lodash/findKey";
import findIndex from "lodash/findIndex";
var getCustomClass = function(obj) {
    if (!obj) return "";
    if (!obj.metadata) return "";
    var index = findIndex(obj.metadata, {
        key: "css_class"
    });
    return index > -1 ? obj.metadata[index].value : "";
};
var mapStateToProps = function(state, _ownProps) {
    var _state_cbook, _state_cbook1;
    var currentExamInteractions = state.exam && state.examInteractions ? state.examInteractions[state.exam.id] : [];
    var chart = state.exam && state.exam.state === "running" && currentExamInteractions ? currentExamInteractions[state.exam.position] : state.nodes.find(function(n) {
        return n.id === state.currentSlide;
    });
    var content = state.loading.indexOf("fetch_content") > -1 ? null : chart && state.contents[chart.id];
    var currentNode = state.nodes.find(function(n) {
        return n.id == state.currentSlide;
    });
    var customClass = "    ".concat(getCustomClass(content), " ").concat(getCustomClass(currentNode), "  ").trim();
    return {
        engagementServerEnabled: Boolean((_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.can_use_engagement_server),
        chart: chart,
        content: content,
        currentNode: currentNode,
        customClass: customClass,
        cBookLang: ((_state_cbook1 = state.cbook) === null || _state_cbook1 === void 0 ? void 0 : _state_cbook1.default_ui_language) || "en",
        exam: state.exam,
        examData: state.exam ? state.examData[state.exam.id] : undefined,
        examInteractions: !!state.exam && ((currentExamInteractions === null || currentExamInteractions === void 0 ? void 0 : currentExamInteractions.map(function(ei) {
            return _objectSpread({}, state.contents[ei.id], ei);
        })) || []) || [],
        storyMode: state.storyMode,
        chartType: chart && (chart.target_type === "Question" && content && content.question_type ? findKey(ChartTypes, {
            qtype: content.question_type
        }) : chart.target_type),
        isLoadingContent: state.loading.indexOf("fetch_content") > -1,
        isLoadingClaims: state.loading.indexOf("fetch_claims") > -1,
        isLoadingInteractions: state.loading.indexOf("fetch_exam_interactions") > -1,
        isLoadingExamData: state.loading.indexOf("get_exam_data") > -1,
        isLoadingSocialChartData: state.loading.indexOf("fetch_social_chart_data") > -1,
        isEvaluated: state.exam ? checkExamQuestionEvaluated(state.exam.id, state.exam.position, state.examInteractions[state.exam.id], state.exam.answers) : false,
        cbook: state.cbook,
        cBookMode: state.cbook && state.cbook.mode || "linear",
        claims: state.claims,
        noteGroup: state.groups.noteGroup,
        users: state.users,
        socialConfig: state.socialConfig,
        session: state.session,
        connections: state.connections,
        socialChartData: content ? state.socialChartData[content.node_id] : null,
        communityChartData: content ? state.communityChartData[content.node_id] : null,
        student: state.student,
        completed: state.completed
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        fetchContent: function(id, nodeType, nodeId) {
            nodeType !== "Exam" && dispatch(fetchContent({
                id: id,
                nodeType: nodeType,
                nodeId: nodeId
            }));
        },
        fetchClaims: function(id) {
            dispatch(fetchClaims({
                id: id
            }));
        },
        fetchGroups: function() {
            dispatch(fetchGroups());
        },
        fetchUsers: function() {
            dispatch(fetchUsers());
        },
        complete: function(id) {
            dispatch(completeSlide({
                id: id
            }));
        },
        progress: function() {
            dispatch(setCbookProgress());
        },
        evaluateInteraction: function(id, examId, correct, selectedAnswers, interactionType) {
            dispatch(evaluateInteraction({
                id: id,
                correct: correct,
                examId: examId,
                selectedAnswers: selectedAnswers,
                interactionType: interactionType
            }));
        },
        startExam: function(id, randomize) {
            dispatch(startExam({
                id: id,
                randomize: randomize
            }));
        },
        initExam: function(id) {
            dispatch(initExam({
                id: id
            }));
        },
        fetchExamInteractions: function(nodeId, targetId) {
            dispatch(fetchExamInteractions({
                nodeId: nodeId,
                targetId: targetId
            }));
        },
        notify: function(id) {
            var messageProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            dispatch(sendNotification({
                key: "content-notification.".concat(id),
                label: "",
                message: id,
                messageProps: messageProps
            }));
        },
        next: function() {
            dispatch(nextSlide());
        },
        login: function() {
            dispatch(login());
        },
        fetchSocialChartData: function(node_id, plugin_id) {
            dispatch(fetchSocialChartData({
                node_id: node_id,
                plugin_id: plugin_id
            }));
        },
        updateSocialChartData: function(node_id, plugin_id, socialChartData) {
            dispatch(updateSocialChartData({
                node_id: node_id,
                plugin_id: plugin_id,
                socialChartData: socialChartData
            }));
        },
        fetchCommunityChartData: function(node_id, plugin_id) {
            dispatch(fetchCommunityChartData({
                node_id: node_id,
                plugin_id: plugin_id
            }));
        },
        acceptDisclaimer: function() {
            dispatch(endorseDisclaimer());
        },
        sendNotification: function() {
            var notification = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            dispatch(sendNotification(notification));
        }
    };
};
function checkExamQuestionEvaluated(examId, position) {
    var interactions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], answers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    // return false if there is no exam
    if (examId === undefined || position === undefined) {
        return false;
    }
    // return whether an answer has been given by the user for the interaction at the current position in the exam
    return !!answers.find(function(a) {
        var currentInteraction = interactions[position];
        if (!!interactions && !!currentInteraction) {
            return a.id === currentInteraction.id;
        } else {
            return false;
        }
    });
}
export default connect(mapStateToProps, mapDispatchToProps)(Component);
